export const BASE_URL_LOCAL = "https://localhost:44375/api";

export const BASE_URL_OLD_WORKING = "http://10.0.1.244/VPassAPI/api";

export const BASE_URL = "https://apps.genus.in/VPassAPI/api";



//  10.0.1.244/VPassAPI/api/TQM/GetVisitor?fromDate=03-01-2025&toDate=03-21-2025
//  curl --location '10.0.1.244/VPassAPI/api/TQM/GetVisitor?fromDate=03-01-2025&toDate=03-21-2025'
//  Above cURL is working on 10.0.1.244 server
//  https://localhost:44375/api/TQM/GetVisitor?fromDate=03-01-2025&toDate=03-21-2025
